import { render, staticRenderFns } from "./AdminGroupServiceLogList.vue?vue&type=template&id=17e01f5a&scoped=true"
import script from "./AdminGroupServiceLogList.vue?vue&type=script&lang=js"
export * from "./AdminGroupServiceLogList.vue?vue&type=script&lang=js"
import style0 from "./AdminGroupServiceLogList.vue?vue&type=style&index=0&id=17e01f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e01f5a",
  null
  
)

export default component.exports